import BlindboxHome from "./home";
import UpgradeRecord from "./upgradeRecord";
import UpgradeS from "./upgradeS";

export default {
  BlindboxHome,
  UpgradeRecord,
  UpgradeS
};